/**
 * planMeta.js — shared plan metadata (label/color/emoji) for subscription cards.
 * Extracted from ProfilePage.jsx so the cards and the page share one source.
 */

export const PLAN_META = {
    ALPHA:    { label: 'Alpha',    color: '#EC4899', emoji: '⚡' },
    BETA:     { label: 'Beta',     color: '#8B5CF6', emoji: '🔮' },
    BASIC:    { label: 'Basic',    color: '#3B82F6', emoji: '⚡' },
    PRO:      { label: 'Pro',      color: '#A855F7', emoji: '🚀' },
    ULTIMATE: { label: 'Ultimate', color: '#F59E0B', emoji: '👑' },
    ACTIVE:   { label: 'Active',   color: '#10B981', emoji: '✓' },
    FREE:     { label: 'Free',     color: '#6B7280', emoji: null },
};
